import { render, staticRenderFns } from "./Crisis_details.vue?vue&type=template&id=0b5987fc&scoped=true"
import script from "./Crisis_details.vue?vue&type=script&lang=js"
export * from "./Crisis_details.vue?vue&type=script&lang=js"
import style0 from "./Crisis_details.vue?vue&type=style&index=0&id=0b5987fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5987fc",
  null
  
)

export default component.exports